import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby-plugin-intl';
import { useTranslate } from 'react-polyglot';

import AccountButton from '../../auth/AccountButton';
import Container from '../Container';
import Logo from '../Logo/Logo';
import MobileHeaderMenu from '../MobileHeaderMenu/MobileHeaderMenu';
import { injectUser } from '../../session';

import './Navigation.scss';

const Navigation = (props) => {
  const {
    authUser, logo, routes, withMenu, sticky, opaque, pushTop,
  } = props;

  const t = useTranslate();

  const [isTop, setIsTop] = React.useState(false);

  let isMounted = true;

  const ref = React.useRef(null);
  const handleScroll = () => {
    if (isMounted) {
      setIsTop(window.scrollY <= 50);
    }
  };

  React.useEffect(() => {
    if (!opaque) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);

      return () => {
        isMounted = false;
        window.removeEventListener('scroll', () => handleScroll);
      };
    }

    return () => {};
  }, []);

  const hasAClass = !!authUser && authUser.hasAClass;
  const hasAClassInProgress = !!authUser && !!authUser.classes && !!authUser.classes.inProgress && Object.keys(authUser.classes.inProgress).length > 0;
  const hasFullPass = !!authUser && authUser.isFullPassActive;

  return (
    <div className="navigation-bar">
      {pushTop && (
        <div className="push-up" />
      )}

      <div className={`navbar-wrapper ${sticky && 'stick'} ${!isTop || opaque ? 'inverse' : ''}`} ref={ref}>
        <div className="sticky">
          <Container>
            <Link to={hasFullPass || hasAClass ? routes.dashboard : routes.landingPage} className="logo-wrapper">
              <Logo logoUrl={logo} />
            </Link>

            {withMenu && (
              <div className="menu-wrapper">
                {!authUser && (
                  <MobileHeaderMenu />
                )}

                <Link className="menu-item mobile-hide tablet-hide-portrait lnk-all-classes" to={routes.pass}>{t('common.toOffer')}</Link>

                <Link className="menu-item mobile-hide tablet-hide-portrait lnk-all-classes" to={routes.allClasses}>{t('common.allClasses')}</Link>

                {!hasFullPass && (
                  <Link className="menu-item mobile-hide tablet-hide-portrait lnk-all-classes" to={routes.pass}>{t('common.payment.passTitle')}</Link>
                )}

                {
                  authUser ? (
                    <>
                      {(hasAClass || hasAClassInProgress) && (
                        <Link className="menu-item mobile-hide tablet-hide-portrait lnk-my-classes" to={routes.myClasses}>{t('common.myClasses')}</Link>
                      )}

                      <AccountButton user={authUser} />
                    </>
                  ) : (
                    <>
                      <Link to={routes.signin} className="menu-item mobile-hide tablet-hide-portrait lnk-signin">{t('common.signin')}</Link>
                    </>
                  )
                }
              </div>
            )}
          </Container>
        </div>
      </div>
    </div>
  );
};

Navigation.propTypes = {
  authUser: PropTypes.object,
  logo: PropTypes.string,
  routes: PropTypes.object.isRequired,
  withMenu: PropTypes.bool,
  sticky: PropTypes.bool,
  opaque: PropTypes.bool,
  pushTop: PropTypes.bool,
};

Navigation.defaultProps = {
  authUser: null,
  logo: null,
  withMenu: true,
  sticky: true,
  opaque: false,
  pushTop: false,
};

export default injectUser(
  Navigation,
);
